// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__3gczN","label":"Input_label__3kKVl","inputElement":"Input_inputElement__32txE","inValid":"Input_inValid__1SQSQ"};